var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
/* eslint-disable sonarjs/elseif-without-else -- WIP*/
/* eslint-disable @typescript-eslint/no-unsafe-argument -- WIP*/
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- WIP*/
import { INITIAL_RESET_RECORD_KEY, ROOT_RESET_RECORD_KEY, STORAGE_RESET_KEY, } from '../../../constants';
import { useUpdateOnly } from '../../../custom-hooks';
import { useFormRoot } from '../../../providers';
import { getNestedValue, shouldBeReset } from '../../../services';
export const useFieldReset = ({ fieldId, resetState, updatedInitialValue, }) => {
    _react_refresh_temp_1();
    const { isUsingStorage, resetFlag, resetRecords } = useFormRoot();
    useUpdateOnly(() => {
        const fieldPath = fieldId.split('.');
        let resetValue;
        if (shouldBeReset({ fieldId, resetFlag })) {
            if (isUsingStorage) {
                resetValue =
                    getNestedValue(resetRecords[resetFlag.resetKey], fieldPath) ??
                        getNestedValue(resetRecords[INITIAL_RESET_RECORD_KEY], fieldPath);
            }
            else {
                resetValue =
                    getNestedValue(resetRecords[resetFlag.resetKey || ROOT_RESET_RECORD_KEY], fieldPath) ?? updatedInitialValue;
            }
            resetState(resetValue);
        }
        else if (resetFlag.resetKey === STORAGE_RESET_KEY) {
            resetValue = getNestedValue(resetRecords[INITIAL_RESET_RECORD_KEY], fieldPath);
            resetState(resetValue);
        }
    }, [resetFlag]);
};
_react_refresh_temp_1(useFieldReset, "yTJW6sHtAUwgfcSMSD7U5ec+2Gk=", false, () => [useFormRoot, useUpdateOnly]);
